import { render, staticRenderFns } from "./ReactionPicker.vue?vue&type=template&id=198ea9f4"
import script from "./ReactionPicker.vue?vue&type=script&lang=ts"
export * from "./ReactionPicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports